<section class="w-100 mt-xxs">
	<div class="d-f mt-xxs mb-xxs w-100" *ngIf="card">
		<div class="d-f mb-xxxs br-md card">
			<a class="c-p d-f ai-c br-md p-xxxs b-s" (click)="clickAction(card.path)">
				<div class="br-md d-f jc-c ai-c p-nano" [ngClass]="[card.color]">
					<img
						src="../../../../assets/icons/{{ card.icon }}.svg"
						alt="Icone - {{ card.icon }}"
					/>
				</div>
				<div class="ml-xxxs d-f fd-c jc-sb h-100">
					<h5 class="fw-bold fs-xs">{{ card.title }}</h5>
					<p class="fs-xxs card__info">{{ card.description }}</p>
					<div class="d-f ai-c">
						<p class="pr-xxxs fw-bold fs-xxs card__acc">Acessar</p>
						<img
							src="../../../../assets/icons/sanus-next.svg"
							alt="Acessar informações cadastrais"
						/>
					</div>
				</div>
			</a>
		</div>
	</div>
	<div class="continer w-100 mt-md mb-huge">
		<h3 class="fw-bold fs-sm continer__dpt mb-xxs">Configurações e regras</h3>
		<div class="d-f f-w w-100">
			<div
				class="d-f mb-xxxs br-md card"
				*ngFor="let item of cards; let i = index"
			>
				<a
					class="c-p d-f ai-c br-md p-xxxs b-s"
					(click)="clickAction(item.path)"
				>
					<div class="br-md d-f jc-c ai-c p-nano" [ngClass]="[item.color]">
						<img
							src="../../../../assets/icons/{{ item.icon }}.svg"
							alt="Icone - {{ item.icon }}"
						/>
					</div>
					<div class="ml-xxxs d-f fd-c jc-sb h-100">
						<h5 class="fw-bold fs-xs">{{ item.title }}</h5>
						<p class="fs-xxs card__info">{{ item.description }}</p>
						<div class="d-f ai-c">
							<p class="pr-xxxs fw-bold fs-xxs card__acc">Acessar</p>
							<img
								src="../../../../assets/icons/sanus-next.svg"
								alt="Acessar informações cadastrais"
							/>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</section>
